export default "__VITE_ASSET__BNeCMUlr__"